<div class="tooltip-wrapper">
  <div class="tooltip-content">
    <div class="tooltip-title">{{ title }}</div>
    <div class="tooltip-subtitle">{{ subtitle }}</div>
  </div>
</div>
